import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';

import { TextFieldGroupBuilder } from './text-field-group-builder';
import { TextFieldGroupConfig } from './text-field-group-config';

@Component({
  selector: 'pcs-text-field-group',
  template: '<ng-content></ng-content>',
  styleUrls: ['./text-field-group.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TextFieldGroupComponent {
  @Input() textFieldConfig: TextFieldGroupConfig = TextFieldGroupBuilder.textFieldGroup();

  @HostBinding('class.horizontal')
  private get horizontal() {
    return this.textFieldConfig.horizontal;
  }
}
